<section>
  <header class="primary">
    <h2>Closed Case</h2>
  </header>
  <main>{{ data.message }}</main>
  <footer>
    <button (click)="onClose()" class="k-button" tabindex="-1">{{ data.cancelButtonText }}</button>
    <button class="k-button" style="float: right" (click)="onConfirmClick()" tabindex="1">
      {{ data.confirmButtonText }}
    </button>
  </footer>
</section>
